module.exports = __webpack_public_path__ + "static/media/백봉산양골산.47610308.jpg";